import { render, staticRenderFns } from "./UserProfileChange.vue?vue&type=template&id=6a4ddbda"
import script from "./UserProfileChange.vue?vue&type=script&lang=js"
export * from "./UserProfileChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports